import React from 'react'
import PropTypes from 'prop-types'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { DatePickerWrap } from './style'
// import { consoleLog } from '../../util'

const MuiDatePicker = ({ label, value, placeholder, name, error, format = 'MM/DD/YYYY', onChange, ...rest }) => {
  // const [open, setOpen] = useState(false)
  const onChangeFunc = (e) => {
    if (!(e?.$y >= 0 && e?.$M >= 0 && e?.$D >= 0)) {
      // Edge case error handling
      return false
    }
    onChange(e)
  }

  return (
    <DatePickerWrap className='DatePickerWrap'>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer components={['DatePicker']}>
          <DatePicker
            // sx={{ width: '100%', overflow: 'hidden' }}
            inputFormat={format}
            slotProps={{ textField: { variant: 'standard' } }}
            onChange={(e) => onChangeFunc(e)}
            // onClose={(e) => consoleLog('Closed', e)}
            label={label}
            // ignoreInvalidInputs={true}
            placeholder={placeholder}
            value={value || null}
          />
        </DemoContainer>
      </LocalizationProvider>
    </DatePickerWrap>
  )
}

MuiDatePicker.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  name: PropTypes.string,
  error: PropTypes.string,
  format: PropTypes.string
}

export default MuiDatePicker
